import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VhQueryAutoWeb, VhEventMediator, VhAlgorithm } from 'vhautowebdb';
import { forkJoin } from 'rxjs';

import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { FunctionService } from 'vhobjects-service/src/services';
import { ColorContrastComponent } from '../../../../color-contrast/color-contrast.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'atw-search-config',
  templateUrl: './search-customize-config.component.html',
  styleUrls: ['./search-customize-config.component.scss'],
})
export class AtwSearchCustomizeConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  // @Input() data_tool: any;
  // @Input() type_config: string;
  @Input() visible_config_tool = false;
  @Input() device: any;
  @Input() type: any; // xem đang ở page hay admin
  @Output() save = new EventEmitter();
  @Output() closeConfigEvent = new EventEmitter();
  @Output() closeConfigTool = new EventEmitter();

  public title = 'Cấu hình thanh tìm kiếm';
  isCollapsed: boolean = false;
  isViewAll: boolean = false;
  currentViewAll: any = {};
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'Mặc định',
      img: '/assets/root/images/system/imgs/gdDefault.png',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'Từ trái sang phải',
      img: '/assets/root/images/system/imgs/gdToRight.png',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'Từ phải sang trái',
      img: '/assets/root/images/system/imgs/gdToLeft.png',
      deg: '270deg',
    },
  ];
  stylefields = [
    {
      title: 'Điều chỉnh viền ô tìm kiếm',
      index: 1,
      isDrop: false
    },
    {
      title: 'Điều chỉnh viền button',
      index: 2,
      isDrop: false
    },
    {
      title: 'Điều chỉnh viền item kết quả',
      index: 3,
      isDrop: false
    },
    {
      title: 'nang_cao',
      index: 4,
    },
    {
      title: "Độ bao phủ",
      index: 5,
      isDrop: false
    },
    {
      title: 'Điều chỉnh viền kết quả',
      index: 6,
      isDrop: false
    },
  ]
  arr_link_page: any = [];
  id_subproject: any = '';

  backgroundColor: any = [
    {
      bgColor: '#000000',
      name: 'Đen',
      hex: '#000000',
    },
    {
      bgColor: '#808080',
      name: 'Xám',
      hex: '#808080',
    },
    {
      bgColor: '#A9A9A9',
      name: 'Xám đen',
      hex: '#A9A9A9',
    },
    {
      bgColor: '#BEBEBE',
      name: 'Xám nhạt',
      hex: '#A9A9A9',
    },
    {
      bgColor: '#C0C0C0',
      name: 'Bạc',
      hex: '#C0C0C0',
    },
    {
      bgColor: '#FFFFFF',
      name: 'Trắng',
      hex: '#FFFFFF',
    },
    {
      bgColor: '#ff1616',
      name: 'Đỏ',
      hex: '#ff1616',
    },
    {
      bgColor: '#F08080',
      name: 'Đỏ san hô',
      hex: '#F08080',
    },
    {
      bgColor: '#EE82EE',
      name: 'Màu tím',
      hex: '#EE82EE',
    },
    {
      bgColor: '#800080',
      name: 'Màu tím',
      hex: '#800080',
    },
    {
      bgColor: '#8c52ff',
      name: 'Màu tía',
      hex: '#8c52ff',
    },
    {
      bgColor: '#FFC0CB',
      name: 'Hồng',
      hex: '#FFC0CB',
    },
    {
      bgColor: '#FF1493',
      name: 'Màu hồng đậm',
      hex: '#FF1493',
    },
    {
      bgColor: '#FFB6C1',
      name: 'Màu hồng nhạt',
      hex: '#FFB6C1',
    },
    {
      bgColor: '#00FFFF',
      name: 'Màu lục lam',
      hex: '#00FFFF',
    },
    {
      bgColor: '#40E0D0',
      name: 'Màu ngọc lam',
      hex: '#40E0D0',
    },
    {
      bgColor: '#00c2cb',
      name: 'Xanh nước biển',
      hex: '#00c2cb',
    },
    {
      bgColor: '#4169E1',
      name: 'Xanh đậm',
      hex: '#4169E1',
    },
    {
      bgColor: '#0000FF',
      name: 'Xanh da trời',
      hex: '#0000FF',
    },
    {
      bgColor: '#008037',
      name: 'Lục',
      hex: '#008037',
    },
    {
      bgColor: '#7ed957',
      name: 'Xanh lá',
      hex: '#7ed957',
    },
    {
      bgColor: '#c9e265',
      name: 'Vàng chanh',
      hex: '#c9e265',
    },
    {
      bgColor: '#ffde59',
      name: 'Vàng',
      hex: '#ffde59',
    },
    {
      bgColor: '#ffbd59',
      name: 'Hồng đào',
      hex: '#ffbd59',
    },
    {
      bgColor: '#ff914d',
      name: 'Cam',
      hex: '#ff914d',
    },
  ];

  fontsListItem = [
    { label: 'Times New Roman', value: 'Times New Roman' },
    { label: 'Georgia', value: 'Georgia' },
    { label: 'Palatino', value: 'Palatino' },
    { label: 'Baskerville', value: 'Baskerville' },
    { label: 'Arial', value: 'Arial' },
    { label: 'Arial black', value: 'Arial Black' },
    { label: 'Verdana', value: 'Verdana' },
    { label: 'Tahoma', value: 'Tahoma' },
    { label: 'Impact', value: 'Impact' },
    { label: 'Gill Sans', value: 'Gill Sans' },
    { label: 'Courier New', value: 'Courier New' },
    { label: 'Lucida', value: 'Lucida' },
    { label: 'Console', value: 'Console' },
    { label: 'Andalé Mono', value: 'Andalé Mono' },
    { label: 'Courier', value: 'Courier' },
    { label: 'Monaco', value: 'Monaco' },
    { label: 'Bradley Hand', value: 'Bradley Hand' },
    { label: 'Brush Script MT', value: 'Brush Script MT' },
    { label: 'Comic Sans MS', value: 'Comic Sans MS' },
    { label: 'Luminari', value: 'Luminari' },

    { label: 'Lobster', value: "'Lobster', cursive" },
    { label: 'Caveat', value: "'Caveat', cursive" },
    { label: 'Roboto', value: "'Roboto', sans-serif" },
    { label: 'Poppins', value: "'Poppins', sans-serif" },
    { label: 'Pacifico', value: "'Pacifico', cursive" },
  ];

  public positionOptions = [
    {
      label: 'Phải',
      value: 'Right',
    },
    {
      label: 'Trái',
      value: 'Left',
    },
  ];

  public checkHideBorderOptions = [
    { label: 'Trên', value: 'top' },
    { label: 'Phải', value: 'right' },
    { label: 'Dưới', value: 'bottom' },
    { label: 'Trái', value: 'left' },
  ];

  /** Danh sách ngành hàng */
  main_sectors: any = [];
  /** Danh sách ngành hàng đã chọn ở Lĩnh vực thiết kế */
  main_sectors_selected: any = [];

  public visibleSubSetting = false;
  public nzTitleSubSetting = 'Tùy chỉnh bo tròn';


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    private vhAlgorithm: VhAlgorithm,
    private http: HttpClient,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
    private matDialog: MatDialog,
  ) {
    if (isPlatformBrowser(this.platformId))
      // Lấy danh sách ngành hàng đã chọn để lát nữa lọc ra danh sách ngành hàng
      this.route.params.subscribe((routeParam) => {
        this.id_subproject = routeParam.id_project;
        this.main_sectors_selected = this.vhQueryAutoWeb.getlocalSubProject(this.vhQueryAutoWeb.getlocalSubProject_Working()._id).main_sectors;
      });
  }


  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Lấy danh sách ngành hàng
      forkJoin([
        this.http.get('assets/data/group/main_sectors.json'),
      ]).subscribe(([main_sectors]: any) => {
        this.main_sectors = this.vhAlgorithm.sortVietnamesebyASC(main_sectors.filter((item) => !['basic', 'branchs', 'member'].includes(item.value)), 'label');
        this.main_sectors = this.main_sectors.filter((item) => this.main_sectors_selected.includes(item.value));
      });

      this.getLinkAllPages();
    }
  }

  ngOnChanges() {
    if (!this.staticdata.accessibility) this.staticdata.accessibility = {}; 
  }

  getLinkAllPages(): void {
    this.vhQueryAutoWeb.getPages().then((pages: any) => {
      // Dùng cho trường hợp trang không có name_vn (Hoặc functionService.defaultLanguage)
      const pagesNew = pages.map((page) => {
        // if (!page.name) console.warn('Không có name', page)
        if (!page['name_' + this.functionService.defaultLanguage] && page.name) {
          return {
            ...page,
            ['name_' + this.functionService.defaultLanguage]: page.name
          };
        } else return page;
      });
      this.arr_link_page = this.vhAlgorithm.sortVietnamesebyASC(pagesNew, 'name_' + this.functionService.defaultLanguage);
    });
  }


  //Mở xem thêm
  openViewAll(field) {
    this.currentViewAll = field;
    this.isViewAll = !this.isViewAll;
  }

  // xử lý chỉ mở được 1 menu 1 lần
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false
  };
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }


  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient =
        this.device == 'desktop'
          ? this.config['background-color']
          : this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['search-customize-box__button'].background = "linear-gradient(" + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['search-customize-box__button'].background = this.config['background-color'].background;
    }
    this.updateObject();
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    // Get class active của element khi click chọn hướng phối màu.
    // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
    var activeGradient = document.querySelector('.active') as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');
    // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
    this.config['background-color'].gradient_type = direction.type;
    this.config['background-color'].gradient_direction = direction.direction;
    this.class['search-customize-box__button']['background'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')'
    this.updateConfig();
    this.updateClass();
  }
  /**Hàm này dùng để click chọn màu nền của danh sách màu.
     * @param bgColor : trả về màu được chọn
     * @param event : trả về element được active
     */
  chooseBg(bgColor, event) {

    // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
    // Lấy ra element màu được click từ tham số event trả về.
    var activeGradient = document.querySelector(
      '.container-color .active'
    ) as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');
    // Lấy giá trị màu được click từ tham số bgColor.
    //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
    const data_background = this.class['search-customize-box__button']
    data_background['background-color'] = bgColor.bgColor;
    data_background['background-color'] = `rgba(${this.hexToRGB(data_background['background-color'])}, ${this.config['background-color'].value_range})`;
    this.updateObject();
  }


  // */ Hàm update object vào database.
  // */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {

      })
  }

  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {

      });
  }

  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
        // data: this.data
      })
      .then((bool: any) => {

      });
  }

  public typeOpenVisibleSubSetting:
    | 'button-radius'
    | 'input-radius'
    | 'input-border'
    | 'button-border'
    | 'input-padding'
    | 'padding-result-search'
    | 'result-search-radius'
    | 'result-search-border';
  public openVisibleSubSetting(
    value:
      | 'button-radius'
      | 'input-radius'
      | 'input-border'
      | 'button-border'
      | 'input-padding'
      | 'padding-result-search'
      | 'result-search-radius'
      | 'result-search-border'
  ) {
    switch (value) {
      case 'button-radius':
        this.nzTitleSubSetting = 'Tùy chỉnh bo tròn nút';
        break;
      case 'input-radius':
        this.nzTitleSubSetting = 'Tùy chỉnh bo tròn ô tìm kiếm';
        break;
      case 'input-border':
        this.nzTitleSubSetting = 'Tùy chỉnh viền ô tìm kiếm';
        this.checkHideBorderOptions[0]['checked'] =
          this.objectChoosing.desktop_input_search.hide_border_top == true
            ? true
            : false;
        this.checkHideBorderOptions[1]['checked'] =
          this.objectChoosing.desktop_input_search.hide_border_right == true
            ? true
            : false;
        this.checkHideBorderOptions[2]['checked'] =
          this.objectChoosing.desktop_input_search.hide_border_bottom == true
            ? true
            : false;
        this.checkHideBorderOptions[3]['checked'] =
          this.objectChoosing.desktop_input_search.hide_border_left == true
            ? true
            : false;
        break;
      case 'button-border':
        this.nzTitleSubSetting = 'Tùy chỉnh viền nút';
        break;
      case 'padding-result-search':
        this.nzTitleSubSetting = 'Tùy chỉnh khoảng cách kết quả tìm kiếm';
        break;
      case 'result-search-radius':
        this.nzTitleSubSetting = 'Tùy chỉnh bo tròn item';
        break;
      case 'result-search-border':
        this.nzTitleSubSetting = 'Tùy chỉnh viền item';
        break;
      default:
        this.nzTitleSubSetting = 'Tùy chỉnh khoảng cách ô tìm kiếm';
    }
    this.visibleSubSetting = !this.visibleSubSetting;
    this.typeOpenVisibleSubSetting = value;
  }
  

//   /**
// * Cập nhật staticdata vào database.
// */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
      });
  }




  /**
 * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
 * @param event width hieght của element sau khi thay đổi
 */
  changeWidthHeight(event) {
    if (event.width) this.class['search-customize-box']['width'] = event.width + 'px';
    if (event.height) this.class['search-customize-box']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  /**
   * Mở popup so sánh màu nền và màu chữ có tương phản hay không
   * (Để tối ưu Accessibility trong SEO)
   */
  openColorContrast() {
    const colorClass = this.class['search-customize-box__button-text'].color ? 'search-customize-box__button-text' : 'search-customize-box__button';
    const dialogRef = this.matDialog.open(ColorContrastComponent, {
      width: '30vw',
      height: 'fit-content',
      data: {
        /** Chứa map màu nền và màu chữ/icon */
        colorContrast: {
          typeFgColor: 'text',
          textOrIconColor: this.class[colorClass].color,
          bgColor: this.class['search-customize-box__button']['background'],
        }
      },
    });

    dialogRef.afterClosed().subscribe((colorContrast) => {
      if (colorContrast) {
        this.class[colorClass].color = colorContrast.textOrIconColor;
        this.class['search-customize-box__button']['background'] = colorContrast.bgColor;
        this.updateClass();
      }
    });
  }
}
